/** Presentation-only Uzbek phone helpers shared by the three web frontends. */
export function formatUzPhone(raw: string | null | undefined): string {
  if (!raw) return "";
  if (!/^[+()\d\s-]+$/.test(raw)) return raw;
  const digits = raw.replace(/\D/g, "");
  if (!/^998\d{9}$/.test(digits)) return raw;
  return `+998 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`;
}

/** The prefix is initial editable content, never a fixed input adornment. */
export function initialPhoneInput(value?: string | null): string {
  return value || "+998";
}

export function isBlankPhoneInput(value: string): boolean {
  const digits = value.replace(/\D/g, "");
  return digits === "" || digits === "998";
}

/** Keep phone search compatible with canonical, unspaced backend values. */
export function phoneSearchQuery(value: string): string {
  const trimmed = value.trim();
  return /^[+\d\s()-]+$/.test(trimmed) ? trimmed.replace(/\D/g, "") : trimmed;
}

/** Format a partially entered Uzbek number while keeping the +998 prefix editable. */
export function formatUzPhoneInput(value: string): string {
  let digits = value.replace(/\D/g, "");
  if (!digits) return "+998";
  if (digits.startsWith("998")) digits = digits.slice(3);
  digits = digits.slice(0, 9);
  const groups = [digits.slice(0, 2), digits.slice(2, 5), digits.slice(5, 7), digits.slice(7, 9)].filter(Boolean);
  return `+998${groups.length ? ` ${groups.join(" ")}` : ""}`;
}

/** Return the canonical value accepted by the existing supplier API. */
export function normalizeUzPhoneInput(value: string): string | null {
  const digits = value.replace(/\D/g, "");
  if (!digits || digits === "998") return null;
  const national = digits.startsWith("998") ? digits.slice(3) : digits;
  return `+998${national.slice(0, 9)}`;
}
